import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const membersReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.MEMBERS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.MEMBERS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.MEMBERS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    
    case actions.MEMBER_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.MEMBER_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.MEMBER_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
  
    case actions.MEMBER_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.MEMBER_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.MEMBER_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const singleMemberReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.MEMBER_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.MEMBER_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.MEMBER_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { membersReducer, singleMemberReducer };
